import { Box, Divider, Stack, SvgIcon } from '@mui/material';

import { InternalLink } from 'common';

import { useSideNavigationAnimation } from '../Animation';
import { SidebarNavigationButton } from '../SidebarNavigationButton';
import { SidebarNavigationSearchBar } from './Search';
import { ReactComponent as NotableLogo } from '../assets/notable-full-logo.svg';
import { SIDEBAR_NAVIGATION_SX_MARGIN_X } from '../constants';
import { SideNavigationState, useSideNavigationModeContext } from '../context';

export function SidebarNavigationTopSection() {
  const { sideNavigationState } = useSideNavigationModeContext();
  const { sideNavigationEnteringAndLeavingAnimation } = useSideNavigationAnimation();

  return (
    <Stack gap={0.5} divider={<Divider />}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" paddingRight={2}>
        <InternalLink
          to="/"
          aria-label="Navigate to home page"
          tabIndex={sideNavigationState === SideNavigationState.Collapsed ? -1 : 0}
          sx={{
            display: 'flex',
            marginX: SIDEBAR_NAVIGATION_SX_MARGIN_X + 0.5,
            paddingTop: 1.5,
            paddingBottom: 2,
            marginY: 0.25,
            transition: '0.2s',
            opacity: 1,
            '&:hover': {
              background: 'transparent',
            },
          }}
        >
          <Box
            sx={{
              width: sideNavigationState === SideNavigationState.Collapsed ? 24 : 120,
              overflow: 'hidden',
              display: 'inline-block',
              ...sideNavigationEnteringAndLeavingAnimation,
            }}
          >
            <SvgIcon
              component={NotableLogo}
              inheritViewBox
              shapeRendering="geometricPrecision"
              sx={{ height: 16, width: 119, display: 'block' }}
            />
          </Box>
        </InternalLink>
        <SidebarNavigationButton />
      </Stack>
      <Box
        sx={{
          marginX: SIDEBAR_NAVIGATION_SX_MARGIN_X,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <SidebarNavigationSearchBar />
      </Box>
    </Stack>
  );
}
